<template>
    <div id="bst-wrap">
        <div class="l-project-wrap l-project-wrap--mypage is-hide">
            <header class="l-header l-header--top">
                <PublicPageHeader />
            </header>
            <section class="l-content-area">
                <div class="l-content">
                    <section class="p-bloc p-bloc--mypage">
                        <div class="p-bloc__content l-wrap__outer">
                            <div class="l-wrap__inner">
                                <section class="p-mypage">
                                    <div class="p-mypage__content">
                                        <div class="mypage-content">
                                            <div class="p-mypage__page mypage-bloc">
                                                <div class="mypage-bloc__content">
                                                    <div class="page__bloc page__bloc--terms c-kiyaku">
                                                        <header class="article-header">
                                                            <h1>ご利用上のご注意</h1>
                                                        </header>
                                                        <!-- post -->
                                                        <section class="article-content">
                                                            <p>このご注意は、お客様が、株式会社ファンテック（以下「当社」といいます）が運営するhubsynch（決済サービス）を利用されるにあたって、必要な注意事項を定めたものです。お客様がhubsynchをご利用されるにあたってはこのご注意を良くお読み下さい。お客様がhubsynchを利用された場合、このご注意に同意されたものとさせていただきます。<br>
                                                                当社はこのご注意の改定を適宜行います。改定の際、お客様に個別にご連絡することは致しかねますので、hubsynchをご利用の都度このご注意を必ずご確認下さいますようお願いいたします。改定後にhubsynchのご利用があった場合、改定後の注意事項に同意されたものとさせていただきます。
                                                            </p>
                                                            <div>
                                                                <h3>当社の免責について</h3>
                                                                <ol>
                                                                    <li>hubsynchは、お客様にオンラインでの決済の「支払方法」を提供するものです。お客様がhubsynchを利用しての決済は、すべてお客様と本サービス加盟店との間で直接行っていただくものです。当社は、売買の当事者とはならず、ご購入に関する責任は負いません。したがって、万一購入に関してトラブルが生じた際には、お客様と本サービス加盟店との間で直接解決していただくことになります。
                                                                    </li>
                                                                    <li>本サービス加盟店、お買い物の内容、取扱商品、サービス、ウェブページ上の記載内容、ショップにおける個人情報の取扱い等につきましては、ショップに直接お問合せください。これらに関する真偽、正確性、最新性、有用性、信頼性、適法性、第三者の権利を侵害していないこと等について当社は一切保証いたしません。
                                                                    </li>
                                                                    <li>通信回線やコンピュータ等の障害によるシステムの中断・遅滞・中止・データの消失、データへの不正アクセスにより生じた損害、その他hubsynchのご利用に関してお客様に生じた損害について、当社は一切責任を負わないものとします。
                                                                    </li>
                                                                    <li>当社は、hubsynchのウェブページ、サーバ、ドメイン等から送られるメール、hubsynch内のコンテンツ等に、コンピュータ・ウィルス等の有害なものが含まれないことを保証いたしません。
                                                                    </li>
                                                                    <li>当社は、お客様および本サービス加盟店に対し、適宜情報提供やアドバイスを行うことがありますが、それにより責任を負うものではありません。
                                                                    </li>
                                                                </ol>
                                                            </div>
                                                            <div>
                                                                <h3>各種規約遵守のお願い</h3>
                                                                <p>hubsynchのご利用に関して当社が別途規約を定める場合がございます。その場合、規約へ同意していただくことがご利用の条件となります。それぞれの規約を熟読の上、遵守くださいますようお願いいたします。
                                                                </p>
                                                            </div>
                                                            <div>
                                                                <h3>禁止事項</h3>
                                                                <p>hubsynchを利用しての購入に際して、次の各号の行為を行うことを禁止いたします。万一、これらに違反された場合、当社はお客様によるhubsynchでの決済を停止したり、以後の決済をお断りすることがあります。また、お客様の違反行為により当社に損害が生じた場合は、その損害を賠償する責任を負うものとします。
                                                                </p>
                                                                <ol>
                                                                    <li>当社、他のお客様、ショップその他の第三者の権利、利益、名誉等を損ねること</li>
                                                                    <li>当初より支払う意思がないにもかかわらず注文するなど真に購入する意思なく商品を注文すること、他人になりすまして注文を行うこと、虚偽の情報を入力すること、その他の不正行為を行うこと
                                                                    </li>
                                                                    <li>法令に違反すること</li>
                                                                    <li>当社が定める各種規約に違反すること</li>
                                                                </ol>
                                                            </div>
                                                            <div>
                                                                <h3>会員登録手続き</h3>
                                                                <ol>
                                                                    <li>会員資格<br>
                                                                        本規約に同意のうえ所定の入会申込みをされた個人は、所定の登録手続完了後に会員としての資格を有します。会員登録手続は、会員となるご本人が行ってください。代理による登録は一切認められません。なお、過去に会員資格が取り消された方やその当社が相応しくないと判断した方からの会員申込についてはお断りする場合があります。
                                                                    </li>
                                                                    <li>会員情報の入力<br>
                                                                        会員登録手続の際には、入力上の注意をよく読み、所定の入力フォームに必要事項を正確に入力してください。
                                                                    </li>
                                                                </ol>
                                                            </div>
                                                            <div>
                                                                <h3>パスワードの管理</h3>
                                                                <p>パスワードは、他人に知られることがないよう定期的に変更する等、会員本人が責任をもって管理してください。入力されたパスワードが登録されたものと一致することを所定の方法により確認した場合、会員による利用があったものとみなし、それらが盗用、不正使用その他の事情により会員以外の者が利用している場合であっても、それにより生じた損害について当グループは一切責任を負いません。
                                                                </p>
                                                            </div>
                                                            <div>
                                                                <h3>登録情報の変更</h3>
                                                                <p>登録した情報に変更が生じた場合は、速やかに変更登録をお願いいたします。変更登録がなされなかったことにより生じた損害について、当社は一切責任を負いません。また、変更登録がなされた場合でも、変更登録前にすでに手続がなされた取引は、変更登録前の情報に基づいて行われます。このような取引について登録情報の変更内容をサービス提供者に通知する必要がある場合には、会員よりサービス提供者に直接ご連絡下さい。
                                                                </p>
                                                            </div>
                                                            <div>
                                                                <h3>会員の退会</h3>
                                                                <p>会員が退会を希望する場合には、会員本人が会員情報の削除を行ってください。所定の退会手続の終了後に、退会となります。
                                                                </p>
                                                            </div>
                                                            <div>
                                                                <h3>クッキー（cookie）等について</h3>
                                                                <p>当社は、お客様のアクセス履歴および利用状況の調査のため、その他お客様に最適のサービスを提供するために、お客様が当社のサーバにアクセスする際のＩＰアドレスに関する情報を収集するとともに、クッキー（cookie）の技術を使用してお客様のアクセス履歴等に関する情報を収集します。お客様がブラウザでクッキーを拒否するための設定を行った場合、hubsynchのサービスのご利用が制限される場合がありますので、あらかじめご了承願います。
                                                                </p>
                                                            </div>
                                                            <div>
                                                                <h3>当社のプライバシーポリシーについて</h3>
                                                                <p>当社は、プライバシーポリシーに従い、個人情報を取り扱います。</p>
                                                            </div>
                                                            <div>
                                                                <h3>hubsynchでのサービス</h3>
                                                                <p>当社は、当社の判断によりhubsynchのサービスのうち、全部または一部を適宜変更・廃止できるものとします。
                                                                </p>
                                                            </div>
                                                            <div>
                                                                <h3>その他</h3>
                                                                <p>お客様と当社との関係につきましては日本法が適用されるものとします。万一、お客様と当社との間に訴訟の必要が生じた場合には、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
                                                                </p>
                                                            </div>
                                                            <div>
                                                                <p style="text-align: right;">以上</p>
                                                                <p>2012年8月17日現在<br>
                                                                    株式会社ファンテック</p>
                                                            </div>
                                                        </section>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
            <Footer v-if="isLoggedIn"/>
            <PublicFooter v-else/>
        </div>
    </div>

</template>
<script setup>
import PublicPageHeader from "@/components/PublicPageHeader.vue";
import { ref, onBeforeMount } from "vue";
import { useSessionStore } from "@/stores/sessionStore";
import Footer from "@/components/Footer.vue";
import PublicFooter from "@/components/PublicFooter.vue";

const sessionStore = useSessionStore();
const isLoggedIn = ref(false);
onBeforeMount(async () => {
    isLoggedIn.value = sessionStore.isLoggedIn();
});
</script>